const PUSH_NOTIFICATION_SHOW_TYPE = {
  DASHBOARD: 'dashboard',
  IMMEDIATE: 'immediate',
};

export default PUSH_NOTIFICATION_SHOW_TYPE;
